import { createSelector } from 'reselect'
import { getSelectedBasicCategory } from 'quick-quote/product-selection/selectors'
import { getRppFundAllocations } from 'quick-quote/product-investment/fund-allocation/rpp/selectors'

export const validateFields = createSelector(
  getSelectedBasicCategory,
  getRppFundAllocations,
  (category, rpulFundAlloc) => ({
    category,
    rpulFundAlloc,
  })
)
